import { useParams , Link} from 'react-router-dom'
import {useState} from 'react'
import {retrieveHelloWorldBean, retrieveHelloWorldPathVariable} from './api/HelloWorldApiService'
import {useAuth} from './security/AuthContext'

export default function WelcomeComponent(){

    const {username} = useParams()

    const [message,setMessage] = useState(null)

    const[divTagVisibile,SetDivTagVisibility] = useState(false)
    const[connectedStatus, setConnectedStatus]= useState("")

    const authContext = useAuth();


    function callHelloWorldRestApi(){
// axios.get('http://localhost:8080/hello-world')
// .then(  (response) => successfullResponse(response))
// .catch((error) => errorResponse(error))
// .finally( () => console.log('cleanup'))


// retrieveHelloWorldBean()
// .then(  (response) => successfullResponse(response))
// .catch((error) => errorResponse(error))
// .finally( () => console.log('cleanup'))

retrieveHelloWorldPathVariable('Validoo',authContext.token)
.then(  (response) => successfullResponse(response),
    setConnectedStatus("Connected to the database."),
    SetDivTagVisibility(true))
.catch((error) => errorResponse(error),
    setConnectedStatus("Not connected to the database. You are using Redux to store your data. Have fun!"),
    SetDivTagVisibility(true))
.finally( () => console.log('cleanup'))


    }

   function successfullResponse(response){
    console.log(response)
    setMessage(response.data.message)
   }

   function errorResponse(response){
    console.log(response)
   }

   
    return(
        <div className="Welcome">
            <h1> Welcome {username} </h1>
            <div>
         Manage  your todos - <Link to="/todos">Go here</Link>
            </div>
            <div>
                 <button className="btn btn-success m-5" onClick={callHelloWorldRestApi}>
                 Check connection to the database!
                     </button> 
{
    divTagVisibile &&
    <p>{connectedStatus}</p>
}

            </div>
          <div className="text-info" >{message}</div>
        </div>
    )
}